import styles from "./Filters.module.css";

import { SEARCH_ATTRIBUTES } from "../../../../../../Queries/Products";

import { useQuery } from "@apollo/client";

import { useTranslation } from "react-i18next";

import FilterText from "../Elements/FilterText";

import { FilterMultiple } from "../Elements/FilterMultiple";

import FilterSelect from "../Elements/FilterSelect";

import FiltersReset from "../Elements/Reset";

import CenterLoader from "../../../../Loaders/CenterLoader";

/**
 * 
 * @exports BatteriesFilters
 * 
 * @description This component renders the filters for the tire collection 
 * 
 * @param { Object } props
 * 
 * @param { Function } props.refetch The refetch function to refetch the tire collection
 * 
 * @param { Object } props.variables The variables to be used to refetch the tire collection
 * 
 * @returns { JSX.Element } BatteriesFilters
 * 
 */

export default function BatteriesFilters ( { refetch, variables } ) { const 

    { t } = useTranslation (),

    { data, loading } = useQuery ( SEARCH_ATTRIBUTES ),

    /**
     * 
     * @constant { Object } componentData
     * 
     * @description This object contains the data for the filters to be rendered in the tire collection.
     * 
     */

    componentData = {

        FilterTextClient: {

            component: FilterText,

            props: { refetch : refetch, variables : variables, name : "client", placeholder : t ( "client" ) },

            dataName: false,
            
            gridOptions: { gridColumn: "1 / 3" }

        },

        FilterTextProductId: {

            component: FilterText,

            props: { refetch : refetch, variables : variables, name : "id", parse : "number", placeholder : t ( "ID" ) },

            dataName: false,

            gridOptions: { gridColumn: "4 / 6" }

        },

        FilterTextEan: {

            component: FilterText,

            props: { refetch : refetch, variables : variables, name : "ean", parse : "number", placeholder : t ( "EAN" ) },

            dataName: false,

            gridOptions: { gridColumn: "6 / 8" }

        },

        FilterMultipleVoltage: {

            component: FilterMultiple,

            props: { refetch : refetch, variables : variables, name : "voltage" },

            dataName: "voltages",

            gridOptions: { gridColumn: "1 / 2" }

        },

        FilterMultipleCurrent: {

            component: FilterMultiple,

            props: { refetch : refetch, variables : variables, name : "current" },

            dataName: "currents",

            gridOptions: { gridColumn: "2 / 3" }

        },

        FilterMultipleCapacity: {

            component: FilterMultiple,

            props: { refetch : refetch, variables : variables, name : "capacity" },

            dataName: "capacities",

            gridOptions: { gridColumn: "3 / 4" }

        },

        FilterTextSize: {

            component: FilterText,

            props: { refetch : refetch, variables : variables, name : "size", placeholder : t ( "size" ) },

            dataName: false,

            gridOptions: { gridColumn: "4 / 6" }

        },

        FilterSelectVendorId: {

            component: FilterSelect,

            props: { refetch : refetch, variables : variables, name : "vendorId", parse : "number", label : "vendor" },

            dataName: "vendors",

            gridOptions: { gridColumn: "6 / 8" }

        },

        FilterMultipleManufacturer: {

            component: FilterMultiple,

            props: { refetch : refetch, variables : variables, name : "manufacturer", textValue : true },

            dataName: "manufacturers",

            gridOptions: { gridColumn: "1 / 3" }

        },

        FilterMultipleModel: {

            component: FilterMultiple,

            props: { refetch : refetch, variables : variables, name : "model", textValue : true },

            dataName: "models",

            gridOptions: { gridColumn: "3 / 6" }

        }

    };

    /** @returns { JSX.Elements } TiresFilters */

    return (

        loading ? <CenterLoader /> :

        <div className={ styles.container }>

            <div className={ styles.content }>

                {
                
                    Object.keys ( componentData ).map
                    
                    ( ( componentKey, index ) => {

                            const { component: Component, props, gridOptions, dataName } = componentData[componentKey];

                            return (

                                <div style={ gridOptions } key={ index }>

                                    <Component { ...props } data={ dataName ? data.searchAttributes.batteries[0][dataName] : null } />

                                </div>

                            );

                        }
                    
                    )
                    
                }

            </div>

            <FiltersReset variables={ variables } refetch={ refetch } />

        </div>

    );

};